import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback, useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";

/**
 * Header Subconta Lista.
 * 
 */

type Props = {
  codigo?: string;
  descricao?: string;
  status?: number;

  onClearFilters: () => void;
  handleCodigoChange: (novoCodigo: string | null) => void;
  handleDescricaoChange: (novaDescricao: string | null) => void;
  handleStatusChange: (novoStatus: number | null) => void;
};


export const Header = ({
  codigo,
  descricao,
  status,
  onClearFilters,
  handleCodigoChange,
  handleDescricaoChange,
  handleStatusChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  useEffect(() => {

  }, []);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-2 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-[40%]">
                <DefaultInput
                  name='codigo'
                  label='Código'
                  value={codigo}
                  onChangeValue={handleCodigoChange}
                />
              </div>

              <div className="w-[40%]">
                <DefaultInput
                  name='descricao'
                  label='Descrição'
                  value={descricao}
                  onChangeValue={handleDescricaoChange}
                />
              </div>


              <div className="w-[20%]">
                <DefaultSelectInput
                  name='status'
                  label='Status'
                  readOnly={false}
                  value={status}
                  onChangeValue={e => handleStatusChange(Number(e))}
                  options={[
                    { id: 2, label: 'Todas' },
                    { id: 0, label: 'Inativas' },
                    { id: 1, label: 'Ativas' },
                  ]} />
              </div>
            </div>


            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}